import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../Redux/Actions/userActions";

// Component Imports
import OrderProcessForm from "./OrderProcessWidget/OrderProcessForm";

// CSS Imports
import "./SearchStyles.css";

const OrderProcess = ({ isOpen }) => {
  const [isProd] = useState(localStorage.getItem("NODE_ENV" || "development") === "production");
  const [errorMessage, setErrorMessage] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

    // Dont show the page if on prod
    if(isProd)
    {
      return (<Navigate to={{pathname: "/",}}/>);
    }

  const processOrder = async (
    email,
    firstName,
    lastName,
    zip,
    BrandId
  ) => {
    
    const options = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Email: email,
        Firstname: firstName,
        Lastname: lastName,
        Zip: zip,
        BrandId: BrandId
      }),
    };

    const res = await fetch("/api/orders/new", options);

    if (res.status === 401) {
      dispatch(logout());
      return navigate("/");
    }
    const { result, message, error } = await res.json();

    if(!error) {
      console.log(result);
      navigate(`/Customer/${result.customerId}`)
    }else {
      setErrorMessage(message);
      setTimeout(setErrorMessage(null), 3500);
    }
  };

  const onHandleSubmit = (email, firstName, lastName, zip, brandId) => {
    console.log(email, firstName, lastName, zip, brandId);
    if(!email || !firstName || !lastName || !zip || !brandId) {
      alert('All fields must be popualted to submit the request');
      return;
    }
    processOrder(email, firstName, lastName, zip, brandId);
  };

  return (
    <div className={`${isOpen ? "page" : "page-closed"} container`}>
      <h3 className="heading">Process New Order</h3>
      <OrderProcessForm
        onClick={onHandleSubmit}
      />
      {errorMessage && <h5
              className="heading"
              style={{
                fontSize: "1rem",
                paddingTop: ".5rem",
                color: "#95f5ac",
              }}
            >
              {errorMessage}
            </h5>}
    </div>
  );
};

export default OrderProcess;
